import {featureAbbr} from "../../configs/constants"
const messages = {
  [`${featureAbbr}.count`]: "order count",
};


export default messages
